import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import _ from 'underscore';

// Set defaults underscore template settings
_.templateSettings = {
	evaluate: /\{\{(.+?)\}\}/g,
	interpolate: /\{\{=(.+?)\}\}/g,
	escape: /\{\{-(.+?)\}\}/g
};

$(() => svg4everybody());

// THEME
import Header from 'partials/site/header/header';
import Overlay from 'blocks/overlay/overlay';
import Router from 'modules/router/router';
import Tooltip from 'blocks/tooltip/tooltip';
import Geo from 'blocks/geo/geo';
import InfoMessage from 'blocks/infomessage/infomessage';

// MAIN
import Blocked from 'portlets/site/blocked/blocked';

import Main from 'portlets/site/main/main';
import ComingSoon from 'portlets/site/coming-soon/coming-soon';
import NoRegion from 'portlets/site/no-region/no-region';

import Roaming from 'portlets/site/roaming/roaming';
import MonthFree from 'portlets/site/month-free/month-free';
import Application from 'portlets/site/application/application';
import InternetTariff from 'portlets/site/internet-tariff/internet-tariff';
import OrderSim from 'portlets/site/order-sim/order-sim';
import OrderSimThankyou from 'portlets/site/order-sim-thankyou/order-sim-thankyou';
import International from 'portlets/site/international/international';
import Helper from 'portlets/site/helper/helper';

// B2B CONNECT
import Connect from 'portlets/site/connect/connect';
import СonnectPromo from 'portlets/site/connect-promo/connect-promo';
// B2B CALLBACK
import Callback from 'portlets/site/callback/callback';

// B2B MODEM
import B2bModemOrder from 'portlets/site/b2b-modem-order/b2b-modem-order';
import B2bTariffModem from 'portlets/site/b2b-tariff-modem/b2b-tariff-modem';
// TABLET
import TabletPromo from 'portlets/site/tablet-promo/tablet-promo';

// YOTA WAY
import YotaWay from 'portlets/site/way/way';


import B2bTariffVoice from 'portlets/site/b2b-tariff-voice/b2b-tariff-voice';
import Selfcare from 'portlets/site/selfcare/selfcare';
import Plankton from 'portlets/site/plankton/plankton';
import AbcParalax from 'portlets/site/abc-paralax/abc-paralax';

import TariffVoice from 'portlets/site/tariff-voice/tariff-voice';

import Info from 'portlets/site/info/info';

// BACKBAY
import BakwayModemOrder from 'scripts/bakway/modem-order/modem-order';

import Showcase from 'portlets/site/showcase/showcase';

import Payment from 'portlets/site/payment/payment';


import RoamingBox from 'portlets/site/roaming-box/roaming-box';
import VoiceMobileApp from 'portlets/site/voice-mobile-app/voice-mobile-app';
import Devices from 'portlets/site/devices/devices';
import TariffMobile from 'portlets/site/tariff-mobile/tariff-mobile';

import Order from 'portlets/site/order/order';
import OrderThankyou from 'portlets/site/order-thankyou/order-thankyou';


// THEME
$(() => new Header().render());
$(() => new Overlay().render());
$(() => new Router().render());
$(() => new Tooltip().render());
$(() => new Geo().render());
$(() => new InfoMessage().render());
// MAIN
$(() => new Blocked().render());

$(() => new Main().render());
$(() => new ComingSoon().render());
$(() => new NoRegion().render());

$(() => new Roaming().render());
$(() => new MonthFree().render());
$(() => new Application().render());
$(() => new InternetTariff().render());
$(() => new OrderSim().render());
$(() => new OrderSimThankyou().render());
$(() => new International().render());
$(() => new Helper().render());

// B2B CONNECT
$(() => new Connect().render());
$(() => new СonnectPromo().render());
// B2B CALLBACK
$(() => new Callback().render());

// B2B MODEM
$(() => new B2bModemOrder().render());
$(() => new B2bTariffModem().render());
// TABLET
$(() => new TabletPromo().render());

// YOTA WAY
$(() => new YotaWay().render());

$(() => new B2bTariffVoice().render());
$(() => new Selfcare().render());
$(() => new Plankton().render());

$(() => new AbcParalax().render());

$(() => new TariffVoice().render());
$(() => new Info().render());


// BACKBAY
$(() => new BakwayModemOrder().render());

$(() => new Showcase().render());

(() => {
	window.InplatPaymentOnInitiated = function () {
		setTimeout(() => $(window).trigger('yota.payment.inplatInitiated'), 1000);
	};

	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://v-jet.inplat.ru/static/js/widget_tsp.js';
	document.body.appendChild(script);

	$(() => new Payment().render());
})();

$(() => new RoamingBox().render());
$(() => new VoiceMobileApp().render());
$(() => new Devices().render());
$(() => new TariffMobile().render());

$(() => new Order().render());
$(() => new OrderThankyou().render());



// WEBPACK FOOTER //
// ./app/scripts/migrate-app.js